import {formatDateTime, random, round2, round2Str} from "../helpers/helpers";

/**
 * pump_ms/analytics/line
 * 15-min interval, local time only, no future points
 */
export const generate_pump_analytics_line_demo = ({
                                                      meter_id,
                                                      start_time,
                                                      end_time,
                                                  }) => {
    const start = new Date(start_time.replace(" ", "T"));
    const end = new Date(end_time.replace(" ", "T"));
    const now = new Date();

    // ❌ future end protection
    const safe_end = end > now ? now : end;

    const pump = [];
    const water_flow = [];
    const energy_meter = [];
    const bearing_vibration = [];
    const de_vibration = [];
    const nde_vibration = [];

    let cursor = new Date(start);
    let total_flow = random(42000, 45000);
    let total_energy = random(1200, 1800);

    while (cursor <= safe_end) {
        const dtime = formatDateTime(cursor);

        // ---------------- Pump pressure ----------------
        const suction = random(1.2, 2.6);
        const discharge = suction + random(2.0, 3.8);

        pump.push({
            meter_id,
            dtime,
            suction_pressure: round2Str(suction),
            discharge_pressure: round2Str(discharge),
        });

        // ---------------- Water flow ----------------
        const flow = random(220, 420);
        total_flow += flow / 4;

        water_flow.push({
            meter_id,
            dtime,
            flow: round2Str(flow),
            total_flow: round2Str(total_flow),
        });

        // ---------------- Energy meter ----------------
        const avg_current = random(35, 85);
        const active_power = random(180, 420);
        total_energy += active_power / 4;

        energy_meter.push({
            meter_id,
            dtime,
            avg_current: round2Str(avg_current),
            total_active_power: round2Str(active_power),
            total_active_energy: round2Str(total_energy),
        });

        // ---------------- Bearing vibration ----------------
        bearing_vibration.push({
            meter_id,
            dtime,
            acceleration_axis_x: round2Str(random(0.02, 0.12)),
            acceleration_axis_y: round2Str(random(0.8, 1.3)),
            acceleration_axis_z: round2Str(random(0.01, 0.08)),
            velocity_axis_x: round2Str(random(0.01, 0.12)),
            velocity_axis_y: round2Str(random(0.01, 0.08)),
            velocity_axis_z: round2Str(random(0.01, 0.15)),
            temperature: round2Str(random(23, 36)),
        });

        // ---------------- DE vibration ----------------
        de_vibration.push({
            meter_id,
            dtime,
            acceleration_axis_x: round2Str(random(0.4, 0.9)),
            acceleration_axis_y: round2Str(random(0.5, 1.1)),
            acceleration_axis_z: round2Str(random(0.2, 0.6)),
            velocity_axis_x: round2Str(random(0.03, 0.12)),
            velocity_axis_y: round2Str(random(0.04, 0.15)),
            velocity_axis_z: round2Str(random(0.02, 0.08)),
            temperature: round2Str(random(26, 42)),
        });

        // ---------------- NDE vibration ----------------
        nde_vibration.push({
            meter_id,
            dtime,
            acceleration_axis_x: round2Str(random(0.03, 0.12)),
            acceleration_axis_y: round2Str(random(0.03, 0.15)),
            acceleration_axis_z: round2Str(random(0.8, 1.3)),
            velocity_axis_x: round2Str(random(0.02, 0.12)),
            velocity_axis_y: round2Str(random(0.02, 0.10)),
            velocity_axis_z: round2Str(random(0.01, 0.06)),
            temperature: round2Str(random(24, 38)),
        });

        // ➕ 15 minutes
        cursor.setMinutes(cursor.getMinutes() + 15);
    }

    return {
        pump,
        water_flow,
        energy_meter,
        bearing_vibration,
        de_vibration,
        nde_vibration,
    };
};